import { get } from '../utils/axios'

export const getPaymentEmployeeSelectAPI = async (param) => {
  return await get('employee/select', param)
}

export const getCostCenterSelectAPI = async (param) => {
  return await get('cost/center/select', param)
}
